import Api from '@/services/api';
//import qs from 'querystring';

export default {
  
  list() {
    return Api().get('/parameters/list');
  },
  save(data) {
    return Api().post('/parameters/list', 'parameters=' + JSON.stringify(data))
  }
}